export const bagSizes = [
  { size: "250g", amount: 250 },
  { size: "500g", amount: 500 },
  { size: "1kg", amount: 1000 },
  { size: "2kg", amount: 2000 },
  { size: "5kg", amount: 5000 },

];
export const grind = [
  "Grano",
  "Chemex",
  "Comercial",
  "Filtro",
  "Prensa Francesa",
  "Italiana",
  "Goteo",
  "Cezve",
  "V60",
  "Espresso",
  "Ibric",
];
